import React, { useContext, useEffect, useState } from "react";
import { AppContext } from "../context/AppContext";
import "bootstrap/dist/css/bootstrap.min.css";
import { Link } from "react-router-dom";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import Loader from "./Loader";

import {
  PostCallWithErrorResponse,
  simpleGetCallWithErrorResponse,
} from "../api/ApiServices";
import ApiConfig from "../api/ApiConfig";
import { ToastMsg } from "./ToastMsg";
import DefaultEditor from "react-simple-wysiwyg";
import DocxUploadButton from "../sharedComponents/DocxUploadButton";

// Editor for the Optional Background Verification policy — same shape as the
// Privacy Policy / Terms & Conditions editors, pointed at the Content-backed
// /content/optional-background-policy endpoint (which returns a sensible default
// when nothing has been saved yet).
const BackgroundVerificationPolicy = () => {
  const { sidebar } = useContext(AppContext);

  const [add, setAdd] = useState(false);
  const handleAddClose = () => setAdd(false);
  const handleAddShow = () => setAdd(true);

  const [loading, setLoading] = useState(false);
  const [validated, setValidated] = useState(false);

  const [policy, setPolicy] = useState({});
  const [contentBody, setContentBody] = useState("");

  useEffect(() => {
    getPolicyApi();
  }, []);

  const getPolicyApi = () => {
    setLoading(true);
    simpleGetCallWithErrorResponse(ApiConfig.OPTIONAL_BACKGROUND_POLICY)
      .then((response) => {
        // `data` is the saved Content doc, or a default object — both have
        // `.content`.
        if (response.json && response.json.data) {
          setPolicy(response.json.data);
          setContentBody(response.json.data.content || "");
        }
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };

  const savePolicy = (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.stopPropagation();
      setValidated(true);
      return;
    }
    PostCallWithErrorResponse(
      ApiConfig.OPTIONAL_BACKGROUND_POLICY,
      JSON.stringify({ body: contentBody })
    )
      .then((res) => {
        if (res.json && res.json.error) {
          ToastMsg("error", res.json.message || "Save failed");
        } else {
          ToastMsg("success", "Background Verification Policy saved");
          if (res.json && res.json.data) {
            setPolicy(res.json.data);
            setContentBody(res.json.data.content || contentBody);
          }
          handleAddClose();
        }
      })
      .catch((err) => {
        console.log(err);
        ToastMsg("error", "Save failed");
      });
    setValidated(true);
  };

  return (
    <main
      id="cx-main"
      className={sidebar ? "admin-main" : "cx-active admin-main"}
    >
      <div className="heading-btn-main">
        <div className="heading-common">
          <label htmlFor="">Background Verification Policy</label>
        </div>
        <div className="add-btn">
          <button onClick={handleAddShow}>
            Update Policy
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              preserveAspectRatio="xMidYMid meet"
              viewBox="0 0 24 24"
            >
              <path fill="white" d="M11 19v-6H5v-2h6V5h2v6h6v2h-6v6Z" />
            </svg>
          </button>
        </div>
      </div>

      <Modal
        show={add}
        onHide={handleAddClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Update Background Verification Policy</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form noValidate validated={validated} onSubmit={savePolicy}>
            <div className="row">
              <div className="col-md-12 mb-3">
                <Form.Label>Background Verification Policy</Form.Label>
                <DocxUploadButton onHtml={setContentBody} />
                <DefaultEditor
                  value={contentBody}
                  onChange={(e) => setContentBody(e.target.value)}
                  placeholder="Enter the Background Verification Policy"
                />
              </div>
            </div>

            <div className="buttons-modal border-top pt-3 text-end ">
              <Link to="#" className=" bg-danger" onClick={handleAddClose}>
                Cancel
              </Link>
              <button className="ms-2" type="submit">
                Save
              </button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>

      <div className="t-c-wrapper">
        {loading ? (
          <div style={{ marginTop: "150px" }}>
            <Loader />
          </div>
        ) : (
          <div className="documents-wrapper user-details-main-card">
            <div className="  user-detail-card">
              <div className="document-cards">
                <div className="t-c-wrapper">
                  <p
                    dangerouslySetInnerHTML={{ __html: policy.content }}
                  ></p>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </main>
  );
};

export default BackgroundVerificationPolicy;
